export default __webpack_public_path__ + "static/media/student-logo-new.35054d20.svg";